// extracted by mini-css-extract-plugin
export default {"Logo":"styles_Logo__v3Spj","invert":"styles_invert__buuzg","LogoText":"styles_LogoText__BSVwM"};